import React from "react";

/**
 * Plain-SVG horizontal bar chart. No charting library.
 * data = [{label, value}]
 */
export function BarChart({ data, total, title, formatValue, preserveCase = false }) {
    const sum = total ?? data.reduce((acc, d) => acc + (d.value || 0), 0);
    const max = Math.max(1, ...data.map((d) => d.value || 0));
    return (
        <div
            className="rounded-2xl border border-klareet-bor bg-klareet-card p-6"
            data-testid={`bar-chart-${title.toLowerCase().replace(/\s+/g, "-")}`}
        >
            {title ? (
                <div className="text-[11px] uppercase tracking-[0.2em] font-mono text-klareet-MUT mb-4">
                    {title}
                </div>
            ) : null}
            <div className="space-y-3">
                {data.map(({ label, value }) => {
                    const pct = sum ? Math.round((value / sum) * 100) : 0;
                    const w = max ? (value / max) * 100 : 0;
                    return (
                        <div key={label}>
                            <div className="flex items-center justify-between text-[13px] mb-1">
                                <span
                                    className={`text-klareet-TEXT ${preserveCase ? "" : "capitalize"}`}
                                >
                                    {preserveCase ? label : label.replace(/_/g, " ")}
                                </span>
                                <span className="font-mono tabular-nums text-klareet-MUT">
                                    {formatValue ? formatValue(value) : value}
                                    <span className="text-klareet-DIM ml-2">
                                        {pct}%
                                    </span>
                                </span>
                            </div>
                            <div className="h-2 rounded-full bg-klareet-BOR overflow-hidden">
                                <div
                                    className="h-full bg-gradient-to-r from-klareet-T to-klareet-T2 rounded-full transition-[width] duration-700 ease-[cubic-bezier(.2,.8,.2,1)]"
                                    style={{ width: `${w}%` }}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
